export const defaultLearnMoreLink =
    'https://support.approvalmax.com/portal/en/kb/articles/pulling-from-xero-step-setup';
